// extracted by mini-css-extract-plugin
export default {"ActiveToggleIcon":"zd836KCmhEk2pxMZTM1yLA=="};